import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import styled, { css } from 'styled-components';
import { buildUrl } from '../../utils';

const commonLinkStyles = () => {
  return css`
    display: inline-block;
  `;
};

const StyledLinkInternal = styled(GatsbyLink)`
  ${commonLinkStyles()};
`;

const StyledLinkExternal = styled.a`
  ${commonLinkStyles()};
`;

export const Link = ({ to, children, ...props }) => {
  const LinkComponent = to ? StyledLinkInternal : StyledLinkExternal;

  return (
    <LinkComponent
      {...(to &&
        (to.charAt(0) !== '#'
          ? {
              to: to === '/' ? to : buildUrl(to),
            }
          : {
              href: to,
            }))}
      {...props}
    >
      {children}
    </LinkComponent>
  );
};
